import {roleClaimCandidates} from "../config/auth-config";

// Der Nutzerkreis kommt als Claim `rolle` aus der Firebase-Identität — es ist
// derselbe Claim, den die Rules prüfen. Welche ZITADEL-Rolle zu welchem
// Nutzerkreis führt, entscheidet allein die Token-Route im Mailserver.
export const ROLLE_ADMIN = "admin";
export const ROLLE_USER = "user";
export const ROLLE_READONLY = "readonly";

export const rechteAusRolle = (rolle) => ({
  isAdmin: rolle === ROLLE_ADMIN,
  canWrite: rolle === ROLLE_ADMIN || rolle === ROLLE_USER,
  isReadonly: rolle === ROLLE_READONLY,
  hasAppAccess:
    rolle === ROLLE_ADMIN || rolle === ROLLE_USER || rolle === ROLLE_READONLY,
});

const normalizeRole = (value) => String(value).trim().toLowerCase();

// Nur noch für Zusatzfunktionen ohne Zugriffsrecht (Hinweiston bei
// Fahraufträgen). Rechte leiten sich nie hieraus ab.
export const extractRolesFromProfile = (profile) => {
  if (!profile) {
    return [];
  }

  for (const claimName of roleClaimCandidates) {
    const claimValue = profile[claimName];

    if (!claimValue) {
      continue;
    }

    if (Array.isArray(claimValue)) {
      return claimValue.map(normalizeRole);
    }

    if (typeof claimValue === "string") {
      return [normalizeRole(claimValue)];
    }

    if (typeof claimValue === "object") {
      return Object.keys(claimValue).map(normalizeRole);
    }
  }

  return [];
};
